module.exports = __webpack_public_path__ + "static/img/Informations.32accba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Instruction/Informations.png
// module id = 1742
// module chunks = 34 35